import PrimeVue from 'primevue/config';
import ShipBob from '@src/themes/shipbob';
import Tooltip from 'primevue/tooltip';
import { ENV } from '@src/env';

const primevueStyleTagsToIgnore = ['variables', 'tooltip'];

export const tooltipStyle = `
.p-tooltip {
  font-size: var(--p-tooltip-font-size);
  line-height: var(--p-tooltip-line-height);
  white-space: nowrap;
}
`;

function addTooltipStyle() {
  const style = document.createElement('style');

  style.appendChild(document.createTextNode(tooltipStyle));

  document.head.appendChild(style);
}

export const addPrimevueStylesToShadowDomMixin = ({ standAlone, $element }) => {
  return {
    mounted() {
      if (!standAlone) {
        const primevueStyleTags = document.querySelectorAll('style[data-primevue-style-id], link[rel="stylesheet"][data-primevue-style-id]');

        primevueStyleTags.forEach((style) => {
          const primevueStyleId = style.getAttribute('data-primevue-style-id');

          if (primevueStyleId && primevueStyleTagsToIgnore.some((ignoreId) => primevueStyleId.includes(ignoreId))) {
            return;
          }

          const shadowRootPrimevueStyleTags = $element.shadowRoot.querySelectorAll('style[data-primevue-style-id], link[rel="stylesheet"][data-primevue-style-id]');

          if (shadowRootPrimevueStyleTags && shadowRootPrimevueStyleTags.length > 0) {
            const duplicate = Array.from(shadowRootPrimevueStyleTags).find((shadowRootStyle) => shadowRootStyle.getAttribute('data-primevue-style-id') === primevueStyleId);

            if (duplicate) {
              duplicate.remove();
            }
          }

          $element.shadowRoot.appendChild(style.cloneNode(true));
          style.remove();
        });
      }
    },
  };
};

export const addPrimevue = (app, options) => {
  let componentVersions = options?.version;
  const currentUrl = window?.location?.href;
  const isMerchantApp = currentUrl?.includes(ENV.MERCHANT_APP_URL) || currentUrl?.includes('localhost:46173');

  app.use(PrimeVue, {
    theme: {
      preset: ShipBob,
      options: {
        darkModeSelector: '.sb-dark-mode',
      },
    },
  });

  if (options && options.standAlone !== undefined && options.$element !== undefined) {
    const skipShadowDomStyles = options.skipShadowDomStylesForChildMFEs || false;

    if (!skipShadowDomStyles && (!isMerchantApp || ENV.ADD_PRIMEVUE_STYLES)) {
      app.mixin(addPrimevueStylesToShadowDomMixin(options));
    }

    if (typeof componentVersions !== 'string') {
      let parsedVersions;

      try {
        parsedVersions = JSON.parse(ENV.COMPONENT_VERSIONS);
      } catch (error) {
        console.warn('Failed to parse COMPONENT_VERSIONS:', error);
        parsedVersions = {};
      }

      if (parsedVersions && typeof parsedVersions === 'object') {
        componentVersions = {
          ...parsedVersions,
          ...componentVersions,
        };
      } else {
        componentVersions = parsedVersions;
      }
    }
  }

  if (componentVersions) {
    app.provide('componentVersions', componentVersions);
  }

  app.directive('tooltip', Tooltip);

  addTooltipStyle();
};
